import {
  getListData,
  getMetadata,
  createRecord,
  deleteRecord
} from '../../../modules/bin/entityHandlers';
import update from '../../../helpers/update';
import {
  ACCESS_KEY_API_PATH,
  ACCESS_KEYS_MESSAGE_CLEAR,
  ACCESS_KEYS_METADATA_REQUESTED,
  ACCESS_KEYS_METADATA_SUCCESS,
  ACCESS_KEYS_METADATA_FAILURE,
  ACCESS_KEYS_LIST_DATA_REQUESTED,
  ACCESS_KEYS_LIST_DATA_SUCCESS,
  ACCESS_KEYS_LIST_DATA_FAILURE,
  ACCESS_KEYS_CREATE_REQUESTED,
  ACCESS_KEYS_CREATE_SUCCESS,
  ACCESS_KEYS_CREATE_FAILURE,
  ACCESS_KEYS_DELETE_REQUESTED,
  ACCESS_KEYS_DELETE_SUCCESS,
  ACCESS_KEYS_DELETE_FAILURE
} from './accessKeyTypes';

import { ACCESS_KEYS_DISABLE_CONFIRMATION_SHOW, ACCESS_KEYS_DISABLE_CONFIRMATION_HIDE } from './accessKeyTypes';

export const clearAccessKeyErrors = (record: any) => ({
  type: ACCESS_KEYS_MESSAGE_CLEAR,
  payload: { key: record }
});

export const getAccessKeyMetadata = (listKey: any) =>
  getMetadata(
    ACCESS_KEY_API_PATH,
    listKey,
    ACCESS_KEYS_METADATA_REQUESTED,
    ACCESS_KEYS_METADATA_SUCCESS,
    ACCESS_KEYS_METADATA_FAILURE
  );

export const getAccessKeyListData = (
  listKey: any,
  id: any,
  request: any,
  invalidate = false,
  cachedData?: any
) =>
  getListData(
    ACCESS_KEY_API_PATH,
    listKey,
    id,
    ACCESS_KEYS_LIST_DATA_REQUESTED,
    ACCESS_KEYS_LIST_DATA_SUCCESS,
    ACCESS_KEYS_LIST_DATA_FAILURE,
    request,
    invalidate,
    cachedData
  );

export const getAccessKeyListDataBySearchTerm = (
  listKey: any,
  id: any,
  request: any,
  searchTerm: string
) => {
  const newRequest = update(request, { text: { $set: searchTerm } });
  return getAccessKeyListData(listKey, id, newRequest, true);
};

export const createAccessKey = (payload: any) =>
  createRecord(
    ACCESS_KEY_API_PATH,
    ACCESS_KEYS_CREATE_REQUESTED,
    ACCESS_KEYS_CREATE_SUCCESS,
    ACCESS_KEYS_CREATE_FAILURE,
    payload,
    null,
    'recordCreate'
  );

export const deleteAccessKey = (id: number) =>
  deleteRecord(
    ACCESS_KEY_API_PATH,
    ACCESS_KEYS_DELETE_REQUESTED,
    ACCESS_KEYS_DELETE_SUCCESS,
    ACCESS_KEYS_DELETE_FAILURE,
    id
  );

export const showDisableConfirmation = (item: any) => ({
  type: ACCESS_KEYS_DISABLE_CONFIRMATION_SHOW,
  payload: item
});

export const hideDisableConfirmation = () => ({
  type: ACCESS_KEYS_DISABLE_CONFIRMATION_HIDE
});
